<ng-container *ngIf="worker">
    <ng-container *transloco="let t">
        <div class="row mb-2">
            <div class="col-md-12">

                <p>{{ t('You can set a safety zone, if they leave this area on any shift the monitors will be alerted.') }}</p>

                <ng-container *ngIf="zoneGroup.value.zone_radius == 0 && create==false">
                    <button cButton class="px-4 text-white btn-info" type="submit" (click)="createZone()">
                        <i class="fa-solid fa-check"></i> {{ t('Create a Safety Zone') }}
                      </button>
                </ng-container>
                <ng-container *ngIf="zoneGroup.value.zone_radius > 0 || create==true">

                  <form [formGroup]="zoneGroup" (ngSubmit)="save()" class="info-form">

                    <div class="form-group row justify-content-between">
                      <div class="col-sm-4">
                        <div class="form-group row mb-2">
                          <label class="col-4 col-form-label text-start text-sm-end">{{ t('Latitude') }}</label>
                          <div class="col-6">
                            <input
                              [formControlName]="'zone_lat'"
                              placeholder="{{ t('Latitude') }}"
                            />
                          </div>
                        </div>

                        <div class="form-group row mb-2">
                          <label class="col-4 col-form-label text-start text-sm-end">{{ t('Longitude') }}</label>
                          <div class="col-6">
                            <input
                              [formControlName]="'zone_lng'"
                              placeholder="{{ t('Longitude') }}"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <button type="button" class="btn btn-outline-primary btn-sm mx-1" (click)="goToLatLng()"><i class="fa-solid fa-location-crosshairs"></i> {{ t('Go') }}</button>
                      </div>
                      <div class="col-sm-4">
                        <button cButton class="px-4 text-white btn-danger float-end btn-sm" type="button" (click)="cancel()">
                          {{ t('Cancel Safety Zone') }}
                        </button>
                      </div>

                    </div>
                    <p>{{ t('Click anywhere on the map to set the center of the safety zone and drag the slider to change the zone size.') }}</p>

                    <ngx-slider formControlName="zone_radius" [(value)]="zoneGroup.value.zone_radius" [options]="options" (userChangeEnd)="changeRadius()"></ngx-slider>

                    <div class="d-grid gap-2 mb-2">
                      <button class="btn btn-info text-white" type="submit">
                        {{ t('Save Safety Zone') }}
                      </button>
                    </div>

                  </form>

                </ng-container>

                <div id="map" style="width:100%;height:600px;" [hidden]="hide_map"></div>

            </div>
        </div>
    </ng-container>
</ng-container>
